<accordion>
  @for (item of savingAgreementNotes; track item; let i = $index) {
    <accordion-group class="list-accounts" #accGroup
      [isOpen]="accGroup?.isOpen || isSelectedSavingAgreementNote(item)">
      <span accordion-heading>
        <div class="account-items font-13 d-flex align-items-center {{ item.subSavingAgreementNotes.length == 0?'last-level':''}}">
          @if (item.subSavingAgreementNotes.length !== 0) {
            <button class="btn" type="button" id="{{item.id}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"
            [ngClass]="{'pl-5': item.subSavingAgreementNotes.length === 0}">
            {{item.name}}
          </span>
          <input type="checkbox" (click)="$event.stopPropagation()" (change)="changeNoteStatus(item, $event)"
            class="account-checkbox" [disabled]="item.mandatory" [checked]="isSelectedSavingAgreementNote(item)">
          </div>
        </span>
        @if (item.subSavingAgreementNotes.length !== 0) {
          <div>
            <app-saving-agreement-note-node [savingAgreementNotes]="item.subSavingAgreementNotes"
              [selectedSavingAgreementNotes]="selectedSavingAgreementNotes"
              (onAddSavingAgreementNote)="addSavingAgreementNote($event)"
              (onDeleteSavingAgreementNote)="deleteSavingAgreementNote($event)">
            </app-saving-agreement-note-node>
          </div>
        }
      </accordion-group>
    }
  </accordion>